//const BASE_URL = "http://192.168.2.67/preparetopass/webservices/"//local

//const BASE_URL = "http://01d162b1.ngrok.io/preparetopass/webservices"//local punit sir

//const BASE_URL = "http://18.191.8.242/preparetopass/webservices/"; //live office

const BASE_URL = 'https://api.diehleducation.com/preparetopass/webservices/'; //live client ---->
//const BASE_URL = "http://71149369bf2b.ngrok.io/p2p/webservices/"; //test

export const LIVE_URL = BASE_URL;

//Api urls
export const Authentication_URL = BASE_URL + 'users/authenticate';
export const Register_URL = BASE_URL + 'users/register';
export const ForgetPassword_URL = BASE_URL + 'users/forgotPassword';
export const GetCompanies_URL = BASE_URL + 'users/getCompanies';
export const GetTotalNumberofFlashcards_URL =
  BASE_URL + 'users/getNumberofFlashCards';
export const SetUserFlashcardCounts_URL = BASE_URL + 'users/saveFlashCard';
export const GetListOfFlashcards_URL = BASE_URL + 'users/getFlashcards';
export const GetMainTopics_URL = BASE_URL + 'users/getMainTopics';
export const GetSubTopics_URL = BASE_URL + 'users/getSubTopicsByID';
export const GetQuestionsByCatID_URL = BASE_URL + 'users/getQuestionsByCatID';
export const ResetHiddenQuestions_URL =
  BASE_URL + 'users/deleteHiddenQuestions';
export const Submit_Test_Response_URL = BASE_URL + 'users/saveQuestionAnswer';
export const Change_Password_URL = BASE_URL + 'users/changePassword';
export const DashBoard_URL = BASE_URL + 'users/user_DashBoard_Detail';
export const LeaderBoard_URL = BASE_URL + 'users/getSimulatedHigestTest';
export const Achievement_URL = BASE_URL + 'users/getUserAchievement';
export const Set_Achievement_URL = BASE_URL + 'users/addUserAchievement';

export const ChallengeSendList_URL = BASE_URL + 'users/getChallengeList';
export const ChallengeAcceptList_URL = BASE_URL + 'users/getChallengeRequest';

export const ChallengeHistoryList_URL = BASE_URL + 'users/getChallengeHistory';

export const SendChallengeRequest_URL = BASE_URL + 'users/ChallengeRequest';
export const SendChallengeHistory_URL =
  BASE_URL + 'users/createChallengeHistory';

export const GetSimulatedTestQuestions_URL =
  BASE_URL + 'users/getSimulatedTest';
export const Submit_Simulated_Test_Response =
  BASE_URL + 'users/saveSimulatedTest';

export const GetVideoMainTopics_URL = BASE_URL + 'users/getVideoMainTopics';
export const GetVideos_URL = BASE_URL + 'users/getVideoLessonByCatID';

export const paymentRequest_URL = BASE_URL + 'users/paymentRequest_v2';

export const getPurchaseStatus_URL = BASE_URL + 'users/paymentStatus';
export const claimYourPurchase_URL = BASE_URL + 'users/claimRequest';

export const promocodeRequest_URL = BASE_URL + 'users/getCouponCode';
export const apply_Promocode_URL = BASE_URL + 'users/validateCouponCode';

export const get_Payment_Info = BASE_URL + 'users/getPaymentInfo';
//Api Method Type
export const POST_METHOD = 'POST';
export const GET_METHOD = 'GET';

var APIMethodEnum = { POST: 1, GET: 2 };
Object.freeze(APIMethodEnum);
